import { useEffect } from 'react';

import { membersRoles } from 'shared/const';

import { listMembers } from './graphql/queries';

export default function useOrganizations({
  useLazyGraphQLQuery,
  organizationId,
  registeredMembers,
  setRegisteredMembers,
}) {
  const [listMembersQuery, listMembersResponse] =
    useLazyGraphQLQuery(listMembers);

  const limit = 1000;

  const getOrganizationManagers = (filterIds = []) => {
    return registeredMembers.reduce((users, member) => {
      if (
        [membersRoles.admin, membersRoles.manager].includes(member.role) &&
        !filterIds.includes(member.user.id)
      ) {
        users.push(member.user);
      }
      return users;
    }, []);
  };

  useEffect(() => {
    if (organizationId) {
      setRegisteredMembers([]);
      listMembersQuery({
        variables: {
          pagination: {
            offset: 0,
            limit,
          },
          filter: {
            organizationId: {
              eq: organizationId,
            },
          },
        },
      });
    }
  }, [organizationId]);

  useEffect(() => {
    const { data, loading } = listMembersResponse;

    if (!loading && data) {
      if (
        data.listMembers.length > 0 &&
        data.listMembers.length % limit === 0
      ) {
        listMembersResponse.fetchMore({
          variables: {
            pagination: {
              limit,
              offset: data.listMembers.length,
            },
          },
        });
      }

      setRegisteredMembers(data.listMembers);
    }
  }, [listMembersResponse]);

  return {
    getOrganizationManagers,
    loadingRegisteredMembers: listMembersResponse.loading,
  };
}
